module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-13.581f5acb.jpg";